// src/pages/ClaimAccountPage.js
//
// The dedicated /claim entry point is now redundant: the new provider-first
// SignupPage auto-detects shadow accounts during the phone lookup step
// (via /auth/lookup → shadowFound) and runs the claim flow against the
// Phase 4a Lambda inline. Preserving the /claim route as a redirect so old
// SMS invites, bookmarks, and outbound business-invite links don't 404.

import { Navigate } from "react-router-dom";

export default function ClaimAccountPage() {
  return <Navigate to="/signup" replace />;
}
